// @ts-nocheck

import { useEffect } from "react";

const PIXEL_ID = "KpwDixVZsxxjykmxaGrnQE";

function loadScript() {
  window.oaiq =
    window.oaiq ||
    function () {
      (window.oaiq.q = window.oaiq.q || []).push(arguments);
    };

  oaiq("init", { pixelId: PIXEL_ID });

  var s = document.createElement("script");
  s.src = "https://bzrcdn.openai.com/sdk/oaiq.min.js";
  s.async = true;
  document.head.appendChild(s);
}

function useChatGptAdsPixel(enabled = false, timeout = 0) {
  useEffect(() => {
    if (!enabled) return;

    const timeoutId = window.setTimeout(loadScript, timeout);

    return () => window.clearTimeout(timeoutId);
  }, [enabled, timeout]);
}

export default useChatGptAdsPixel;
